/* Pošiljalac dokumenata (opomene, obaveštenja) — jedino mesto za podatke firme koja ih izdaje. */
const POSILJALAC = {
    naziv: 'Dujić Konsalting',
    punNaziv: 'KATICA DUJIĆ PR ORGANIZOVANJE PREVOZA I DRUGE USLUGE DUJIĆ KONSALTING BEOGRAD',
    adresa: 'Vidikovački venac 104v',
    mesto: '11000 Beograd (Rakovica)',
    grad: 'Beograd', // mesto u datumu dokumenta
    pib: '110048185',
    maticniBroj: '64610201',
    potpisnik: 'Katica Dujić, preduzetnik',
};

export default POSILJALAC;
